// When the pipeline view re-sorts. The view is frozen (order and stage sections) until a filter changes,
// the set of loans changes, or the user asks to regroup. Only a real filter change drops the loans pinned
// as "new this session"; regrouping refreshes the frozen stages and keeps them.

export interface SnapshotKeys {
  /** Filters, grouping and sort as one string. */
  filter: string;
  /** Bumped by "Stages changed · regroup". */
  generation: number;
  /** The loan ids in the cache, sorted and joined. */
  ids: string;
}

export function snapshotChange(prev: SnapshotKeys | null, next: SnapshotKeys): { rebuild: boolean; clearPins: boolean } {
  if (!prev) return { rebuild: true, clearPins: false };
  return {
    rebuild: prev.filter !== next.filter || prev.generation !== next.generation || prev.ids !== next.ids,
    clearPins: prev.filter !== next.filter,
  };
}
